// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lUhWf","text":"Footer_text__mRGcH"};